var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBb = function SvgBb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M17.218 1.19A11.952 11.952 0 0 0 12 0c-1.87 0-3.64.428-5.217 1.19L5.739 12l1.044 10.81A11.953 11.953 0 0 0 12 24c1.87 0 3.64-.428 5.218-1.19L18.26 12 17.218 1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M6.783 1.191A12 12 0 0 0 0 12.001a12 12 0 0 0 6.783 10.808V1.191ZM17.218 1.192v21.617A12 12 0 0 0 24 12a12 12 0 0 0-6.782-10.808Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m15.652 7.303.7.35-.7-.35-.7-.35c-.042.085-.956 1.945-1.106 4.785h-1.064V7.303L12 6.26l-.783 1.043v4.435h-1.064c-.15-2.84-1.063-4.7-1.106-4.785l-1.4.7c.01.02.961 1.956.961 4.868v.782h2.609v4.435h1.565v-4.435h2.609v-.782c0-1.506.26-2.747.479-3.524.238-.846.48-1.34.483-1.345l-.701-.349Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgBb;